import type { LinkPaymentMethod } from '../../openApi';
import { OrderPaymentMethods } from './OrderPaymentMethods';

export const OrderPrePaymentMethods: Array<LinkPaymentMethod> = [OrderPaymentMethods.CARD_ONLINE];
